/** Reopens membership review of this exact approval so changed work is reapproved or withdrawn explicitly. */
import { Injector } from '@angular/core';
import { ActivityEntityName } from '@jms/model';
import { EntityDialogs } from '@workbuddy/ui/v2/blocks/entity.dialog/entity.dialog.contracts';
import { ApprovalVisitsBoardParams } from '../visit.approval.detail.model';
import { reloadApproval } from './approval.command.support';

export async function reviewApprovalChanges(injector: Injector, params: ApprovalVisitsBoardParams): Promise<void> {

  if (!params.canRemove) return;
  const { approval, scope, hostReadonly } = params;
  await injector.get(EntityDialogs, null)?.open({
    entity: ActivityEntityName.VisitApproval,
    operation: 'edit',
    id: approval._id,
    params: { approvalId: approval._id, scope, readonly: hostReadonly },
    afterSave: () => {
      void reloadApproval(injector, params);
    },
  });
}
